import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { _ExternalLinkWrapper } from "./style";
import { API_ROOT } from "../../../../../constants/consts";
function truncate(filename) {
  if (!filename) return '';
  if (filename.length < 25) return filename;
  return "".concat(filename.substring(0, 9), "...").concat(filename.substring(filename.length, filename.length - 9));
}
var ExternalLinksAdditionalAttachments = function ExternalLinksAdditionalAttachments(_ref) {
  var externalLinks = _ref.externalLinks,
    additionalAttachments = _ref.additionalAttachments;
  var linksAndAttachments = useMemo(function () {
    return externalLinks.concat(additionalAttachments);
  }, [externalLinks, additionalAttachments]);
  return /*#__PURE__*/React.createElement(_ExternalLinkWrapper, null, linksAndAttachments.map(function (item) {
    if (item.type === 'application_external_links') {
      return /*#__PURE__*/React.createElement("span", {
        key: "application_external_links-".concat(item.id)
      }, /*#__PURE__*/React.createElement("a", {
        href: item.attributes.link,
        target: "_blank",
        rel: "noreferrer"
      }, item.attributes.link));
    }
    return /*#__PURE__*/React.createElement("span", {
      key: "application_additional_attachments-".concat(item.id)
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(API_ROOT).concat(item.attributes.link),
      target: "_blank",
      rel: "noreferrer"
    }, truncate(item.attributes.file_name)));
  }));
};
export default ExternalLinksAdditionalAttachments;